import {Reducer} from "redux";
import {createSelector} from "reselect";
import {AppRootState} from "./root-reducer";
import {ChatMsgState, initialChatMsgState, ChatMsg, FrontendActionInfo} from "../types/chat-msg-types"
import { ChatMsgActions } from "../actions/chat-msg-actions";

export const chatMsgReducer: Reducer<ChatMsgState> = (state = initialChatMsgState, action) => {
    switch (action.type) {
        case ChatMsgActions.ADD_CHAT_MESSAGE:
            // let chatMsg = state.chatMsg;
            if (action.payload.msg !== "") {
                // chatMsg.map(item => {
                //     if(item.type === "buddy_msg") {item.isHistoryMsg=true; return item;}
                // })
                // console.log("change --------------",chatMsg);
                state.chatMsg.push(action.payload);
            }
            return {...state};
        case ChatMsgActions.REMOVE_CHAT_MESSAGE:
            state.chatMsg.pop();
            return {...state};
        case ChatMsgActions.SHOW_LOADING_ICON:
            return {
                ...state,
                showLoading: action.payload
            }
        case ChatMsgActions.SET_FRONTEND_ACTION:
            return {
                ...state,
                frontendAction:action.payload
            }
        case ChatMsgActions.SUGGESTION_INPUT:
            return {
                ...state,
                suggestionInput: action.payload
            }
        case ChatMsgActions.RETRIEVE_LAST_SESSION_RESULT:
            // delete first object e.g LOAD_HISTORY_MSG
            let newChatMsg = state.chatMsg;
            console.log("00000start history by sessionId0000000", newChatMsg);
            console.log("action.payload: ", action.payload.newChatMsg);
            if (action.payload && action.payload.newChatMsg && action.payload.newChatMsg.length > 0) {
                // var newArr = state.chatMsg.filter((val, index) => {
                //     return index !== 0
                // })
                var newArr:ChatMsg[] = [];
                if(state.chatMsg && state.chatMsg.length) {
                    newArr = state.chatMsg.filter((val: any, index: any) => {
                        return index !== 0
                    })
                }
                newChatMsg = action.payload.newChatMsg.concat(newArr);
            }
            return {
                ...state,
                chatMsg: newChatMsg
            }
        case ChatMsgActions.RESET_CHAT_MSG_RESULT:
            return{
                ...state,
                chatMsg: []
            }
        case ChatMsgActions.UPDATE_NOTIFY_STATUS:
            return {
                ...state,
                haveNotify: action.payload
            }
        case ChatMsgActions.UPDATE_ACTIVE_CONTEXT:
            return {
                ...state,
                activeContext: action.payload
            }
        default:
            return state
    }
}

const chatMsgList = (state: AppRootState) => state.chatMsg;
export const getChatMsgList = createSelector([chatMsgList], (data) => data);

const showLoading = (state: AppRootState) => state.chatMsg.showLoading;
export const getShowLoading = createSelector([showLoading], (data) => data);

const haveNotify = (state: AppRootState) => state.chatMsg.haveNotify;
export const getHaveNotify = createSelector([haveNotify], (data) => data);

const frontendAction =(state:AppRootState)=> state.chatMsg.frontendAction;
export const getFrontEndAction = createSelector([frontendAction], (data) => data);

const activeContext =(state:AppRootState)=> state.chatMsg.activeContext;
export const getActiveContext = createSelector([activeContext], (data) => data);
